import { useHandlers } from '../../../context/page-context';
import type { PriceListsApiContract } from '../api';

export function usePriceListsApi(): { priceListsApi: PriceListsApiContract } {
  const { apis } = useHandlers();
  return { priceListsApi: apis.priceLists };
}
